import React from "react"
import PropTypes from "prop-types"
import { Link } from "gatsby"
import Img from "gatsby-image"

const BlogPreview = ({ title, slug, image, excerpt, date }) => (
  <div className="row">
    <div className="col-2"></div>
    <div className="col-md">
      <h2><Link to={slug}>{title}</Link></h2>
      <p>Posted on {date}</p>
      <p>{excerpt}</p>
    </div>
    <div className="col-md">
      <Link to={slug}>
        <Img sizes={image}></Img>
      </Link>
    </div>
    <div className="col-1"></div>
  </div>
)

BlogPreview.propTypes = {
  title: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  excerpt: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
};

export default BlogPreview